import UserActiveIcon from "../icons/UserActiveIcon";
import { useSession } from "next-auth/react";
import { useImageLockedCountByUser } from "@/hooks/image/useImageLockedCountByUser";

export const UserActivLink = () => {
  const { data: session } = useSession();
  const user = session?.user;

  const { lockedCount, isError, isLoading } = useImageLockedCountByUser(
    user?.id ? { userUuid: user.id } : null
  );

  if (isLoading || isError) {
    return <UserActiveIcon />;
  }

  if (lockedCount < 1) {
    return <UserActiveIcon />;
  }

  return <UserActiveIcon notificationCount={lockedCount} />;
};

export default UserActivLink;